// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pt-6";
export var imgContainer = "_pt-3";
export var menuIcon = "_pt-5";
export var pillWrapper = "_pt-2";
export var pillsContainer = "_pt-1";
export var subscriptionCard = "_pt-0";
export var subscriptionLogo = "_pt-4";